export function ticket_types(type, tilt, bg) {
	let bgOrIcon = (typeof bg !== 'undefined' && bg !== null) ? bg + '-' : '',
		ticket_types = {
			'single': {
				icon: 'ticket'
			},
			'season': {
				icon: 'season-ticket'
			},
			'bulk': {
				icon: 'bulk-ticket'
			},
			'vip': {
				icon: 'vip-ticket'
			},
			'addon': {
				icon: 'ticket'
			},
		};
	return bgOrIcon + tiltOrFlat(tilt) + ticket_types[type].icon;
}

function tiltOrFlat(tilt) {
	if (tilt) {
		return 'icon-tilt-';
	}
	return 'icon-flat-'
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/ticketIcons.js